export default {
  observee: 'data-comp-observee',
  observeeCallback: 'data-comp-observee-callback',
  observeeThreshold: 'data-comp-observee-threshold',
  observedClass: 'observed',
};
